import { AlertsAppBaseDataProvider } from './AlertsAppBaseDataProvider';

export class AlertsAppNirvanaDataProvider extends AlertsAppBaseDataProvider {}
